<template>
  <div class="login_container">
    <div class="logo">
      <a href="" class="logo_index">
        <img src="../image/logo.png" width="100%" height="100%" alt="logon"/></a>
    </div>
    <div class="background">
      <!-- < img src="../image/bgi-login.png" width="100%" height="100%" alt="" /> -->
    </div>
    <!-- 登录模块 -->
    <div class="login_box" v-if="isShow">
      <div class="login_title">智能民宿房间管理系统</div>
      <div class="login_input">
        <el-form ref="loginFrom" :model="loginFrom" :rules="rules">
          <el-form-item prop="username">
            <el-input v-model="loginFrom.username" placeholder="请输入账号"
              ><i
                slot="prefix"
                class="el-input__icon iconfont iconshoujizhanghao"
              ></i
            ></el-input>
          </el-form-item>

          <el-form-item prop="password">
            <el-input
              v-model="loginFrom.password"
              type="password"
              placeholder="请输入密码"
              show-password
              ><i slot="prefix" class="el-input__icon iconfont iconmima"></i
            ></el-input>
          </el-form-item>
          <div class="verificationCode_input">
            <el-input
              v-model="loginFrom.code"
              type="text"
              placeholder="请输入动态验证码"
            >
              <i
                slot="prefix"
                class="el-input__icon iconfont iconyanzhengma"
              ></i
            ></el-input>
            <div class="get_code" @click="verification_Btn">
              <img
                v-if="verification_img"
                :src="verification_img"
                alt="获取验证码"
              />
            </div>
          </div>
          <el-form-item>
            <el-form-item>
              <div @click="forgetPasswprd" class="forget">忘记密码?</div>
              <div class="remember">
                <el-checkbox v-model="checked">记住密码</el-checkbox>
              </div>
            </el-form-item>
            <el-form-item>
              <el-button
                type="warning"
                @click="onSubmit()"
                style="width: 100%; background: #f6b439; font-size: 18px"
                >登录</el-button
              >
            </el-form-item>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <!-- 忘记密码 -->
    <div class="login_box" v-else>
      <div class="login_title">忘记密码</div>
      <div class="login_input">
        <el-form ref="forget" :model="forget" :rules="rules">
          <el-form-item prop="username">
            <el-input
              v-model="forget.username"
              clearable
              placeholder="请输入私人手机号"
            ></el-input>
          </el-form-item>
          <el-form-item class="flexBox">
            <el-input
              clearable
              v-model="forget.verification"
              placeholder="请输入手机验证码"
            ></el-input>
              <el-button type="primary" :disabled="butText!='发送验证码'" @click="sendCode">{{butText}}</el-button>
          </el-form-item>
          <el-form-item prop="password">
            <el-input
              v-model="forget.password"
              type="password"
              placeholder="请输入新密码"
              show-password
            ></el-input>
          </el-form-item>
          <el-form-item prop="newPassword">
            <el-input
              v-model="forget.newPassword"
              type="password"
              placeholder="再次输入新密码"
              show-password
            ></el-input>
          </el-form-item>

          <el-form-item>
            <el-form-item>
              <el-button
                type="warning"
                @click="confirm"
                style="width: 100%; background: #f6b439; font-size: 18px"
                >确定</el-button
              >
            </el-form-item>
            <el-form-item>
              <div @click="backtrack" class="backtrack">返回登录</div>
            </el-form-item>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { VerificationAjax, LoginAjax, authorize, getUrl,sendPhoneCodeAjax,restPwd } from "../api/index";
import { GetItem, SetItem } from "../utils/storage";

export default {
  data() {
    //表单验证
    var validatorPassword = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("密码不能为空"));
      } else if (!/^[a-zA-Z0-9]{3,20}$/.test(value)) {
        callback(new Error("密码格式错误,必须且只含有数字和字母，3-20位!"));
      } else {
        callback();
      }
    };
    //账号正则
    var validatorcPersonName = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("账号不能为空"));
        // } else if (!/^[a-zA-Z0-9]{3,10}$/.test(value)) {
        //   callback(new Error("账号格式错误,必须且只含有数字和字母，3-10位!"));
      } else {
        callback();
      }
    };
    // 再次输入新密码
    var validatorCheckPass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.forget.password) {
        console.log(this.value);
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };

    return {
        timeNum:60,
        timeTask:null,
      isShow: true,
      verification_img: "", //获取的验证码图片
      checked: false, //是否记住密码
      // 表单数据

      loginFrom: {
        username: GetItem("username") || "",
        password: GetItem("password") || "",
        uuid: "",
        code: "", //输入的验证码
      },
        butText:'发送验证码',
      // 忘记密码
      forget: {
        username: "",
        password: "",
        newPassword: "",
        verification: "",
      },
      // 校验
      rules: {
        username: [
          {
            required: true,
            validator: validatorcPersonName,
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            validator: validatorPassword,
            trigger: "blur",
          },
        ],
        newPassword: [
          {
            required: true,
            validator: validatorCheckPass,
            trigger: "blur",
          },
        ],
      },
    };
  },
  // 引入组件

  created() {
    this.$store.state.user = "";
    // this.refreshCode();
    this.verification_Btn();
    let that = this;
    document.onkeypress = function (e) {
      var keycode = document.all ? event.keyCode : e.which;
      if (keycode == 13) {
        that.onSubmit(); // 登录方法名
        return false;
      }
    };
  },
  methods: {
    // 获取验证
    async verification_Btn() {
      const { data: res } = await VerificationAjax();
      if (res.code == 200) {
        this.verification_img = "data:image/gif;base64," + res.img;
        this.loginFrom.uuid = res.uuid;
      }
    },

    onSubmit() {
      //   二次校验
      this.$refs.loginFrom.validate(async (valid) => {
        if (
          this.loginFrom.username.length == 0 &&
          this.loginFrom.password.length == 0
        ) {
          this.$message({
            type: "error",
            message: "账号和密码不能为空",
          });
        }
        if (!valid) {
          return;
        }
        // 发送请求
        const { data: res } = await LoginAjax(this.loginFrom);
        if (res.code !== 200) {
          this.$message({
            message: res.msg,
            type: "error",
          });
          this.loginFrom.code = '';
          this.verification_Btn();
        } else {
          this.$message({
            message: "登录成功",
            type: "success",
          });
          // 存储token
          this.$store.commit("setUser", res.token);
          // this.$store.commit("setMT");
          // 是否保存账号密码
          if (this.checked == true) {
            SetItem("username", this.loginFrom.username);
            SetItem("password", this.loginFrom.password);
          } else {
            SetItem("username", "");
            SetItem("password", "");
          }
            this.$router.push("/home");
            /*authorize({
                uri:'https://test.youjiaminsu.cn/dist/auth'
            }).then(result => {
                console.log(result,'获取美团授权地址')
                // alert(result.data.data)
                this.$router.push("/home");
                setTimeout(()=>{
                    this.$confirm('你还没有授权美团账号，是否前往授权?', '提示', {
                        confirmButtonText: '去授权',
                        cancelButtonText: '稍后再说',
                        type: 'warning'
                    }).then(() => {
                        window.location = result.data.data;
                    }).catch(() => {

                    });
                },1500)
            })*/
          // this.$router.push("/home");
        }
      });
    },
    // 新密码确定按钮
    confirm() {
      console.log(this.forget);
      if(this.forget.password!=this.forget.newPassword){
          return this.$message.warning("密码不一致,请重新输入")
      }
        restPwd({phone:this.forget.username,password:this.forget.password,code:this.forget.verification}).then(res=>{
            if(res.data&&res.data.code==200){
                this.$message.success("修改成功")
                this.forget={
                    username: "",
                    password: "",
                    newPassword: "",
                    verification: "",
                }
                this.loginFrom={
                    username: GetItem("username") || "",
                    password: GetItem("password") || "",
                    uuid: "",
                    code: "", //输入的验证码
                }
            }else {
                this.$message.error(res.data.msg)
            }
        })
    },
    //忘记密码
    forgetPasswprd() {
      this.isShow = false;
    },
    // 返回登录
    backtrack() {
      this.isShow = true;
    },
      //发送验证码
      sendCode(){
          let part = /^((13\d)|(14[5,7,9])|(15[0-3,5-9])|(166)|(17[0,1,3,5,7,8])|(18[0-9])|(19[8,9]))\d{8}/;
          if(!part.test(this.forget.username)){
              return this.$message.error('手机号不正确请重新输入')
          }

          sendPhoneCodeAjax({phone:this.forget.username}).then(res=>{
              if(res.data&&res.data.code==200){
                  this.$message.success('发送成功')
                  this.timeTask=setInterval(()=>{
                      this.timeNum-=1;
                      this.butText=this.timeNum+"秒"
                      console.log("倒计时:"+this.timeNum)
                      if( this.timeNum==0){
                          clearInterval(this.timeTask);
                          this.timeTask=null;
                          this.butText='发送验证码'
                          this.timeNum=60
                      }
                  },1000)
              }else {
                  this.$message.error(res.data.msg)
              }
          })
      }
    // 获取随机验证码
    // refreshCode() {
    //   //
    //   this.identifyCode = "";
    //   this.makeCode(this.identifyCodes, 4);
    // },
    // randomNum(min, max) {
    //   max = max + 1;
    //   return Math.floor(Math.random() * (max - min) + min);
    // },
    // makeCode(data, len) {
    //   for (let i = 0; i < len; i++) {
    //     this.identifyCode += data[this.randomNum(0, data.length - 1)];
    //   }
    // }
  },
};
</script>

<style lang="less" scoped>
.login_container {
  .background {
    width: 100%;
    height: 100%; /**宽高100%是为了图片铺满屏幕 */
    z-index: -1;
    position: absolute;
    background: url(../image/bgi-login.png) center, center;
    background-size: auto 100%;
    background-repeat: no-repeat;
  }
  .login_box {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateY(-50%);
    background-color: #fff;
    box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.2);
    width: 500px;

    border-radius: 12px;
    padding: 0 70px 67px 70px;
    .login_title {
      text-align: center;
      width: 240px;
      margin: 60px 50px 44px 60px;
      font-size: 24px;
      font-weight: 600;
    }
  }
  .logo {
    .logo_index {
      display: inline-block;
      width: 100%;
      height: 100%;
    }
    position: absolute;
    top: 64px;
    left: 32px;
    width: 200px;
    height: 130px;
  }
}

.verificationCode_input {
  height: 42px;

  .el-input {
    float: left;
    width: 245px;
  }
  .get_code {
    overflow: hidden;
    border-radius: 5px;
    float: right;
    width: 106px;
    height: 40px;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
.iconfont {
  font-size: 24px;
}
/deep/.el-input__prefix {
  left: 10px;
  transition: all 0.3s;
}
/deep/.el-input--prefix .el-input__inner {
  padding-left: 44px;
}
.remember {
  font-size: 14px;
  font-weight: 500;
  float: left;
}
.forget {
  cursor: pointer;
  float: right;
}
.backtrack {
  text-align: center;
  cursor: pointer;
  color: #f6b439;
}
a {
  font-size: 14px;
  font-weight: 500;
  color: #000000;
  text-decoration: none;
}
.el-button {
  margin-top: 20px;
}
/deep/ .flexBox .el-form-item__content{
    display: flex;
    justify-content: space-between;
    align-items: center;
    .el-button{
        margin-top: 0;
        margin-left: 10px;
        width: 180px;
    }
}
</style>
